export default __webpack_public_path__ + "static/114-f5e834bb0f26b6dabdbcaa54d2dee42a.jpg";